<template>
	<div class="user-update">
		<v-container v-if="user">
			<v-card>
				<v-card-title class="dark--text subtitle-1 font-weight-bold">
					<v-row class="px-3 py-3">
						<v-col cols="12" md="3">
							<v-row>
								<v-btn depressed rounded class="secondary mx-2" dark @click="() => $router.go(-1)">
									<v-icon>keyboard_arrow_left</v-icon>
								</v-btn>
								အသုံးပြုသူဒေတာ ပြင်မည်
							</v-row>
						</v-col>

						<v-col cols="12" md="9">
							<v-row justify="end">
								<v-btn depressed class="primary mx-1 my-1" @click="handleUpdateUser"
									:loading="updateLoading">
									<v-icon>save</v-icon>
									သိမ်းမည်
								</v-btn>
							</v-row>
						</v-col>
					</v-row>
				</v-card-title>

				<v-divider></v-divider>

				<v-card-text>
					<v-row>
						<v-col cols="12" md="6">
							<v-text-field class="mt-3" label="အမည်" outlined v-model="username"></v-text-field>

							<v-text-field class="mt-3" label="မှတ်ပုံတင်နံပါတ်" outlined
								v-model="nrcNumber"></v-text-field>
						</v-col>

						<v-col cols="12" md="6">
							<v-textarea class="mt-3" label="လိပ်စာ" outlined v-model="address"></v-textarea>
						</v-col>

						<v-col cols="12">
							<h4>မွေးနေ့</h4>
						</v-col>

						<v-col cols="2">
							<v-text-field class="mt-3" label="နေ့" outlined v-model="birthDate"
								placeholder="dd"></v-text-field>
						</v-col>

						<v-col cols="2">
							<v-text-field class="mt-3" label="လ" outlined v-model="birthMonth"
								placeholder="mm"></v-text-field>
						</v-col>

						<v-col cols="2">
							<v-text-field class="mt-3" label="နှစ်" outlined v-model="birthYear"
								placeholder="YYYY"></v-text-field>
						</v-col>

					</v-row>

					<v-row>
						<!-- NRC FRONT -->
						<v-col cols="12" md="6">
							<h4>NRC Front</h4>

							<v-img v-if="nrcFront" :src="nrcFront" max-height="200" max-width="300"
								class="mb-3"></v-img>
							<v-btn class="primary my-5" small rounded depressed :loading="isFrontSelecting"
								@click="() => onFileSelect('front')">
								<v-icon>cloud_upload</v-icon>
								ပုံတင်မည်
							</v-btn>
							<input ref="nrcFront" class="d-none" type="file" accept="image/*"
								@change="(e) => onFileChange(e, 'nrcFront')" />
						</v-col>

						<!-- NRC BACK -->
						<v-col cols="12" md="6">
							<h4>NRC Back</h4>

							<v-img v-if="nrcBack" :src="nrcBack" max-height="200" max-width="300" class="mb-3"></v-img>

							<v-btn class="primary my-5" small rounded depressed :loading="isBackSelecting"
								@click="() => onFileSelect('back')">
								<v-icon>cloud_upload</v-icon>
								ပုံတင်မည်
							</v-btn>
							<input ref="nrcBack" class="d-none" type="file" accept="image/*"
								@change="(e) => onFileChange(e, 'nrcBack')" />
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-container>
	</div>
</template>

<script>
import User from "../../api/model/User"
import File from "../../api/model/File"

export default {
	name: "UserUpdate",

	data: function () {
		return {
			userId: this.$route.params.userId,
			loading: false,
			user: null,

			updateLoading: false,

			username: null,
			profile: null,
			nrcNumber: null,
			address: null,

			birthDate: null,
			birthMonth: null,
			birthYear: null,

			nrcFront: null,
			nrcBack: null,

			selectedFile: null,
			isFrontSelecting: false,
			isBackSelecting: false
		}
	},

	methods: {
		onFileSelect: function (type) {
			if (type === "front") {
				this.isFrontSelecting = true;
				this.$refs.nrcFront.click();
			} else {
				this.isBackSelecting = true;
				this.$refs.nrcBack.click();
			}

			window.addEventListener(
				"focus",
				() => {
					this.isFrontSelecting = false;
					this.isBackSelecting = false;
				},
				{ once: true }
			);
		},
		onFileChange: async function (e, type) {
			this.selectedFile = e.target.files[0]

			try {
				let result = await File.uploadPhoto(
					this.selectedFile,
					"news",
					this.token
				)

				console.log("result: ", result)

				if (type === "nrcFront") {
					this.nrcFront = result.url
				}

				if (type === "nrcBack") {
					this.nrcBack = result.url
				}

				this.isFrontSelecting = false;
				this.isBackSelecting = false;
			} catch (error) {
				console.log("Error : ", error)
			}
		},

		handleUpdateUser: async function () {
			this.updateLoading = true

			let body = {
				username: this.username,
				nrcNumber: this.nrcNumber,
				address: this.address,

				birthday: `${this.birthDate}-${this.birthMonth}-${this.birthYear}`,
				birthdayDate: parseInt(this.birthDate),
				birthdayMonth: parseInt(this.birthMonth) - 1,

				isMale: this.user.isMale,

				nrcFront: this.nrcFront,
				nrcBack: this.nrcBack,
			}

			try {
				await User.updateInfo(this.userId, body, this.token)

				this.updateLoading = false

				this.$router.go(-1)
			} catch (error) {
				console.log(error)
				this.updateLoading = false
			}
		},

		getUserData: async function () {
			this.loading = true

			try {
				let result = await User.getInfo(this.userId, this.token)

				this.user = result

				this.username = result.username
				this.profile = result.profile
				this.nrcNumber = result.nrcNumber
				this.address = result.address

				this.nrcFront = result.nrcFront
				this.nrcBack = result.nrcBack

				let birthdayString =
					new Date(result.birthday).toLocaleDateString("en-CL") ==
						"Invalid Date"
						? result.birthday
						: new Date(result.birthday)
							.toLocaleDateString("en-IN")
							.replaceAll("/", "-")

				let birthdayArray = birthdayString.split("-")

				this.birthDate = birthdayArray[0]
				this.birthMonth = birthdayArray[1]
				this.birthYear = birthdayArray[2]
			} catch (error) {
				console.log(error)
			}

			this.loading = false
		},
	},

	created: async function () {
		await this.getUserData()
	},

	computed: {
		token: function () {
			return this.$store.state.user.token
		},
	},
}
</script>